import { defineComponent } from "vue";
const _sfc_main = defineComponent({
  name: "Upload"
});
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 24 24"
};
const _hoisted_2 = /* @__PURE__ */ _createElementVNode("path", {
  "fill-rule": "evenodd",
  d: "M4.5 12.75L5.5575 13.8075L11.25 8.1225V22.5H12.75V8.1225L18.4425 13.8075L19.5 12.75L12 5.25L4.5 12.75ZM4.5 6V3H19.5V6H21V3C21 2.17157 20.3284 1.5 19.5 1.5H4.5C3.67157 1.5 3 2.17157 3 3V6H4.5Z",
  "clip-rule": "evenodd"
}, null, -1);
const _hoisted_3 = [
  _hoisted_2
];
function _sfc_render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_3);
}
import _export_sfc from "/plugin-vue/export-helper";
export default /* @__PURE__ */ _export_sfc(_sfc_main, [["render", _sfc_render], ["__file", "/Users/yimingtian/projects/ym/yimian-ui/packages/icons/src/Upload.vue"]]);
